import { ReactNode, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import {
  Box,
  Button,
  Container,
  Drawer,
  Group,
  LoadingOverlay,
  ScrollArea,
  Title,
} from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';

import Footer from '@components/layout/Footer';

import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';
import classes from './AuthenticatedLayout.module.css';

interface LayoutProps {
  children?: ReactNode;
  title?: ReactNode | string;
  loading?: boolean;
  backLink?: {
    title: string;
    to: string;
  };
  rightSection?: ReactNode;
}
export default function AuthenticatedLayout({
  children,
  title,
  loading,
  backLink,
  rightSection,
}: LayoutProps) {
  const [opened, setOpened] = useState(false);

  const onHamburgerClick = useCallback(() => {
    setOpened(true);
  }, []);

  const onLinkClick = useCallback(() => {
    setOpened(false);
  }, []);

  return (
    <>
      <Header onHamburgerClick={onHamburgerClick} />
      <Group align="start" gap={0} wrap="nowrap" style={{ height: '100vh' }}>
        <Drawer
          opened={opened}
          onClose={() => setOpened(false)}
          hiddenFrom="md"
          size="100%"
          position="right"
        >
          <Sidebar onLinkClick={onLinkClick} />
        </Drawer>

        <Box visibleFrom="md">
          <Sidebar onLinkClick={onLinkClick} />
        </Box>

        <ScrollArea className={classes.scrollArea}>
          <LoadingOverlay visible={loading || false} />
          <Container size={1400} className={classes.container}>
            <div style={{ flexGrow: 1 }}>
              {backLink && (
                <Button
                  component={Link}
                  to={backLink.to}
                  variant="light"
                  size="xs"
                  mb="lg"
                  leftSection={<IconChevronLeft />}
                >
                  {backLink.title}
                </Button>
              )}
              <Group justify="space-between" mb="xl">
                {title && <Title order={1}>{title}</Title>}
                {rightSection}
              </Group>
              {children}
            </div>
            <Footer />
          </Container>
        </ScrollArea>
      </Group>
      {/* <BottomNavbar /> */}
    </>
  );
}
